// extracted by mini-css-extract-plugin
export default {"sheetTitle":"CrmTextModal_sheetTitle__Nu6cX","sheetContent":"CrmTextModal_sheetContent__oKbTQ"};